<template>
  <base-layout :query="require('@/graphql/Reco.gql')" :variables="{slug: this.$route.params.pathology}">
    <template v-slot:title-reco="props">
      <top :slug="props.data.pathologies.edges[0].node.slug" :titleText="props.data.pathologies.edges[0].node.title" :nameText="props.data.pathologies.edges[0].node.name" class="blue"/>
    </template>

    <!-- Form -->
    <template v-if="fetchingQuestionData || fetchingRecoData" v-slot:main-section-reco>
      <Loading />
    </template>
    
    <template v-slot:profile-section v-else-if="!profile">
      <form-profiles @formProfileSubmitted="profile = true"/>
    </template>

    <template v-slot:main-section-reco="props" v-else>
      <v-form v-if="questionData && !isReco" :data="questionData" :bookmarks="questionData.question.node.bookmarks" />
      <v-form-reco v-else :data="recommendationData" />
    </template>

    <!-- Bloc "En savoir plus" -->
    <template v-slot:learn-about="props">
      <learn-more :content="props.data.pathologies.edges[0]"></learn-more>
    </template>

    <!-- Colonne de droite - Etude + Actu -->
    <template v-slot:card-section="props">
      <div class="author u-align--left" v-if="props.data.trees.edges.length">
        <h4>Source de l’algorithme</h4>
        <span><strong>Élaboration de la recommandation&nbsp;:</strong></span>
        <div v-html="props.data.trees.edges[0].node.algoSource"></div>
      </div>
      <card-study :study="props.data.studies.edges[0]" :flatButton="true"></card-study>
      <card-simple-actu :actu="props.data.infos.edges[0]" :flatButton="true"></card-simple-actu>
    </template>

    <template v-slot:modal-section>
      <modal-study :study="studyDataModal"
                    @close="closeModal"
                    v-show="isModalVisible"
      />
    </template>

  </base-layout>
</template>

<script>
  import BaseLayout from "../components/Layout/BaseLayout";
  import VForm from "../components/Form/VForm";
  import VFormReco from "../components/Form/VFormReco"
  import Top from "./../components/Core/Top"
  import FormProfiles from './../components/Form/VFormProfiles'
  import { mapActions, mapGetters } from 'vuex'
  import gql from 'graphql-tag'
  import CardStudy from "../components/Card/Models/Card-study";
  import CardSimpleActu from "../components/Card/Models/Card-simple-actu";
  import LearnMore from "../components/LearnMore/LearnMore";
  import ModalStudy from "../components/Modal/Models/Modal-study";
  import Loading from "./../components/Core/Loading"


  export default {
    name: 'Questionnary',
    components: {ModalStudy, LearnMore, CardSimpleActu, CardStudy, VForm, BaseLayout, Top, FormProfiles, VFormReco, Loading},
    data: () => {
      return {
        skipFirstQuery: false,
        questionData: false,
        isReco: false,
        currentStudy: false,
        isModalVisible: false,
        recommendationData: false,
        studyDataModal: false,
        fetchingQuestionData: false,
        fetchingRecoData: false,
        profile: true
      }
    },
    apollo: {
      trees: {
        skip() {
          return this.skipFirstQuery === true
        },
        query() {
          return gql`query($pathology_slug: String) {
                        trees(pathology_slug: $pathology_slug) {
                          edges {
                            node {
                              enabled,
                              algoSource,
                              pathology {
                                title
                              },
                              firstQuestion {
                                _id
                              }
                            }
                          }
                        }
                      }`
        },
        variables() {
          return {
            pathology_slug: this.$route.params.pathology
          }
        },
        result(ApolloQueryResult) {
          this.skipFirstQuery = true

          if (ApolloQueryResult.data.trees.edges.length) {
            this.setCurrentQuestionId(ApolloQueryResult.data.trees.edges[0].node.firstQuestion._id)
            this.pushQuery(this.getCurrentQuestionId, false)
          } else {
            this.fetchingQuestionData = false
            this.fetchingRecoData = false
            this.buildPreviousQuestions([], [])
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        getCurrentQuestionId: 'getCurrentQuestionId',
        answerSelected: 'getAnswerSelected',
        getPreviousQuestionById: 'getPreviousQuestionById'
      })
    },
    methods: {
      closeModal() {
        this.isModalVisible = false;
      },
      pushQuery(questionId, answerSelected) {
        let query = {}
        query[`q${questionId}`] = answerSelected
        this.$router.push({ name: 'recommendation_pathology', query: query })
      },
      ...mapActions(
        {
          setCurrentQuestionId: 'setCurrentQuestionId',
          setPreviousQuestions: 'setPreviousQuestions',
          setAnswerSelected: 'setAnswerSelected'
        }
      ),
      checkProfile() {
        if (this.$cookies.isKey('profile')) {
          this.profile = this.$cookies.get('profile')
        } else {
          this.profile = false
        }
      },
      getRecommendation(recoId) {
        this.fetchingRecoData = true

        const recommendationQuery = gql`
          query($id: Int)  {
            recommendations(id: $id) {
              edges {
                node {
                  id,
                  _id,
                  title,
                  warning,
                  footer,
                  sections (order: {weight: "ASC"}){
                    edges {
                      node {
                        id
                        pertinence
                        title
                        date
                        body
                        grade0
                        grade1
                        grade2
                        grade3
                        expertOpinion
                        notaBene
                        grade4
                        grade5
                      }
                    }
                  }
                }
                cursor
              }
            }
          }
        `

        this.$apollo.query({
          query: recommendationQuery,
          variables: {
            id: recoId
          }
        }).then( result => {
          this.recommendationData = result.data.recommendations.edges.length ? result.data.recommendations.edges[0].node : false
          this.fetchingRecoData = false
        })
      },
      getPreviousQuestions() {
        this.fetchingQuestionData = true

        const previousQuestionsQuery = gql`
          query($ids: [Int]) {
            questions(id_list: $ids) {
              edges {
                node {
                  title,
                  titleSummary,
                  type,
                  nextQuestion,
                  _id,
                  titleSummary,
                  seeMoreContent {
                    title,
                    _id
                  },
                  study {
                    _id,
                    title,
                    chapo,
                    slug,
                    pathology {
                      title,
                      name
                    },
                    type,
                    subscriptionUrl,
                    contactName,
                    contactEmail,
                    maxSubscriptionDate,
                    updatedAt,
                  }
                  answers(order: {weight: "ASC"}) {
                    edges {
                      node {
                        title,
                        image,
                        body,
                        imageUrl,
                        _id,
                        typeOptions,
                        seeMoreContent {
                          title,
                          _id
                        }
                      }
                    }
                  },
                  bookmarks (order: {weight: "ASC"}){
                    edges {
                      node {
                        id
                        title
                        weight
                        anchorHref
                      }
                    }
                  }
                },
                cursor
              }
            }
          }`

        this.$apollo.query({
          query: previousQuestionsQuery,
          variables: {
            ids: this.idsQuestionsUrl
          }
        }).then( result => {
          this.buildPreviousQuestions(this.idsQuestionsUrl, result.data.questions.edges)
          this.fetchingQuestionData = false
        })
      },
      setNextQuestion(question) {
        let scriptContainer = document.getElementById('custom-scripts')

        let script = document.createElement('script')
        let inlineScript = document.createTextNode('function execute(response, responses) {' + question +'}')

        script.setAttribute('type', 'text/javascript')
        script.setAttribute('language', 'javascript')
        script.appendChild(inlineScript)

        if (scriptContainer.childNodes.length) {
          scriptContainer.removeChild(scriptContainer.childNodes[0])
        }

        scriptContainer.appendChild(script)
      },
      /**
       *
       * @param questionsId Used to know the order. We could have used questionsData only, however the order is not correct, it is ordered by id asc.
       * @param questionsData
       */
      buildPreviousQuestions(questionsId, questionsData) {
        let dataFormatted = {};
        let dataFormattedOrdered = [];

        questionsData.map(question => {
          let answerSelected = this.$route.query[`q${question.node._id}`]
          let formattedAnswerSelected = []
          let answerFound = false

          if (Array.isArray(answerSelected)) {
            answerSelected.map(answerId => {
              formattedAnswerSelected = formattedAnswerSelected.concat(question.node.answers.edges.filter(answer => answer.node._id === parseInt(answerId)))
            })
          } else {
            formattedAnswerSelected = question.node.answers.edges.filter(answer => answer.node._id === parseInt(answerSelected))
          }

          let item = {
            question: question,
            answerSelected: formattedAnswerSelected
          }

          if (item.question.node._id === this.getCurrentQuestionId) {
            this.questionData = item
            this.setNextQuestion(item.question.node.nextQuestion)
          }

          dataFormatted[question.node._id] = item;
        });

        questionsId.map(function(id) {
          dataFormattedOrdered.push(dataFormatted[id]);
        });

        this.setPreviousQuestions(dataFormattedOrdered)
      }
    },
    created () {
      this.checkProfile()
    },
    mounted () {
      let scriptContainer = document.createElement('div')
      scriptContainer.setAttribute("id", "custom-scripts")

      this.$el.insertAdjacentElement('afterend', scriptContainer)
    },
    watch: {
      "$route.query": {
        handler: function(val) {
          this.idsQuestionsUrl = []
          let queryArray = []
          let questionInLocal = false

          if (Object.keys(val).length > 0) {
            this.skipFirstQuery = true

            Object.keys(val).map((key, index) => {
              let qId = key

              if (qId.includes('q')) {
                qId = key.split('q')[1]
              }

              if (!Array.isArray(val[key])) {
                val[key] = typeof val[key] !== 'object' ? parseInt(val[key]) : val[key]
              } else {
                val[key] = val[key].map(id => parseInt(id))
              }

              queryArray.push({questionId: qId, answerId: val[key]})
            })
          }

          queryArray.map((item, index) => {
            if (item.questionId !== 'reco') {
              this.idsQuestionsUrl.push(parseInt(item.questionId))
            }

            if (index === queryArray.length - 1) {
              this.getPreviousQuestions()

              if (item.questionId !== 'reco') {
                this.setCurrentQuestionId(parseInt(item.questionId))
                this.setAnswerSelected(item.answerId)
                this.recommendationData = false
                this.isReco = false
              } else {
                this.isReco = true
                this.setCurrentQuestionId(false)

                if (item.answerId && item.answerId !== 'false') {
                  this.getRecommendation(parseInt(item.answerId))
                } else {
                  this.recommendationData = false
                }
              }
            }
          })
        },
        immediate: true
      },
      questionData: {
        handler: function(val) {
          if (val.question.node.study) {
            this.studyDataModal = val.question.node.study

            let questionCookie = this.$cookies.get('showModal_' + this.studyDataModal._id)

            if (questionCookie == null) {
              this.$cookies.set('showModal_' + this.studyDataModal._id, 1)
              this.isModalVisible = true
            } else {
              this.isModalVisible = parseInt(this.$cookies.get('showModal_' + this.studyDataModal._id))
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  .recommandation-form {
    box-shadow: 0 2px 6px 0 rgba(0,0,0,0.08);
    border: 1px solid color(border);
  }

  .author {
    font-size: rem(14px);
    line-height: rem(24px);
    margin-bottom: rem(30px);

    h4 {
      font-size: rem(22px);
      margin: 0 0 rem(15px) 0;
    }

    p {
      margin: 0;
    }

    @include mq($until: SM) {
      padding-top: rem(20px);
    }
  }
</style>
